import styled from 'styled-components';
import { minWidth } from 'helpers/buildMediaQueries';
import { gutterVariables } from '@trustedshops/tps-seo-shared-frontend-react-components';

export const ShopResultList = styled.main`
  margin-bottom: ${gutterVariables.GUTTER_HALF};
  padding: 0 ${gutterVariables.GUTTER};
  grid-area: 3 / 1 / 4 / 2;
  ${minWidth('sm', 'grid-area: 3 / 2 / 4 / 4; padding: 0;')}
  ${minWidth('xl', 'margin-bottom: 48px; grid-area: 3 / 3 / span 2 / 3;')}
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${gutterVariables.GUTTER_DOUBLE};

  ${minWidth('xl', 'margin-top: 40px;')}
`;
